module.exports = __webpack_public_path__ + "static/img/8.b838811.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/trainPlan/10sportDesc/8.svg
// module id = mwHy
// module chunks = 0